/**
 * Button Widget for RUL Forms
 */

import { Button } from 'antd';
import type { ButtonWidget } from '@/api/types/rul.types';

interface ButtonWidgetProps {
  widget: ButtonWidget;
  onClick?: () => void;
}

export const ButtonWidgetComponent: React.FC<ButtonWidgetProps> = ({
  widget,
  onClick,
}) => {
  if (!widget.visible) return null;

  const getButtonType = () => {
    switch (widget.style) {
      case 'primary':
        return 'primary';
      case 'danger':
        return 'primary'; // Ant Design uses danger prop separately
      case 'link':
        return 'link';
      default:
        return 'default';
    }
  };

  return (
    <Button
      type={getButtonType()}
      htmlType={widget.button_type || 'button'}
      disabled={!widget.enabled}
      danger={widget.style === 'danger'}
      onClick={onClick}
      block
    >
      {widget.text}
    </Button>
  );
};
